module.exports = __webpack_public_path__ + "img/rellopay-logo.cebe311f.svg";